import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import { Pagination, Autoplay }  from 'swiper/modules';

// Connects to data-controller="carousel-swiper"
export default class extends Controller {

  connect() {
    this.carousel = this.element.querySelector('.swiper-container');
    this.itemsPerView = this.element.getAttribute('data-items-per-view');
    this.mobileItemsPerView = this.element.getAttribute('data-mobile-items-per-view');
    this.pagination = this.element.getAttribute('data-pagination');
    this.autoScroll = this.element.getAttribute('data-autoscroll');
    this.autoScrollSmooth = this.element.getAttribute('data-autoscroll-smooth');
    this.loop = false;
    this.freeMode = false;
    this.speed = 500;
    this.breakpoints = {};

    this.renderPagination();
    this.assignSpeed();
    this.assignAutoScroll();
    this.assignBreakpoints();
    this.initSwiper();
  }

  renderPagination() {
    if (this.pagination == 'true') {
      this.element.querySelector('.swiper-wrapper').insertAdjacentHTML('afterend', '<div class="swiper-pagination"></div>');
    } else{
      return 'false';
    }
  }

  assignSpeed() {
    const interval = this.element.getAttribute('data-autoscroll-interval');
    this.speed = interval ? interval : 500;
    console.log('Speed assigned:', this.speed);
  }  

  assignAutoScroll() {
    if (this.autoScroll == null || this.autoScroll == 'false' || !this.autoScroll) {
      this.autoScroll = false;
    } else if (this.autoScroll == 'true') {
      this.loop = true;
      this.freeMode = true;
      this.pagination = false;
      
      if (this.autoScrollSmooth === 'false' || this.autoScrollSmooth === false) {
        this.autoScroll = {
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        };
      } else if (this.autoScrollSmooth === 'true' || this.autoScrollSmooth === true) {
        this.autoScroll = {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        };
      }
    }
  }

  assignBreakpoints() {
    this.breakpoints = {
      0: {
        slidesPerView: this.mobileItemsPerView ? Number(this.mobileItemsPerView) : 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centerInsufficientSlides: false,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: this.itemsPerView,
        slidesPerGroup: 1,
        spaceBetween: 24,
        centerInsufficientSlides: true,
        centeredSlides: true,
      },
    };
  }

  initSwiper() {
    const controller = this;
    
    const swiper = new Swiper(this.carousel, {
      modules: [Pagination, Autoplay],
      slidesPerView: this.itemsPerView,
      spaceBetween: 10,
      wrapperClass: 'swiper-wrapper',
      autoplay: this.autoScroll,
      loop:this.loop,
      freeMode: this.freeMode,
      freeModeMomentum: true,
      speed: this.speed,
      on: {
        touchStart: function () {
          this.params.speed = 200;
          if (this.autoplay && this.autoplay.running) {
            this.autoplay.stop();
          }          
        },
        touchEnd: function () {
          setTimeout(() => {
            this.params.speed = controller.speed;
            if (this.autoplay && !this.autoplay.running) {
              this.autoplay.start();
            }
            console.log(this.params.speed);
          }, 3000);
        },
      },
      effect: 'slide',
      centeredSlides: true,
      breakpoints: this.breakpoints,
      pagination: {
        enabled: this.pagination,
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function () {
          return '<span class="swiper-pagination-bullet">'+"</span>";
        },        
      },
    });
  }



}
